// extracted by mini-css-extract-plugin
export var downArrow = "_7x-0";
export var label = "_7x-1";
export var treatmentCard = "_7x-3";
export var upArrow = "_7x-2";